import api from "PFCore/api";
import { HighlightsParam } from "PFCore/types/highlights_param";
import { Id, Match, PaginatedCollection } from "PFTypes";
import { QueryParams } from "PFTypes/query_params";

export type MatchesPayload = {
  refresh?: boolean;
  refreshMode?: "match_scores" | "all_scores";
} & HighlightsParam &
  QueryParams;

export const fetchMatches = (
  activityId: Id,
  payload: MatchesPayload = { page: 1, perPage: 10 }
): Promise<PaginatedCollection<Match[]>> =>
  api({
    url: "matches/index",
    method: "POST",
    data: { activityId, ...payload }
  });
